import {
	Table as MUITable,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableProps,
	TableRow,
	Pagination,
	Box,
} from '@mui/material';
import { TableHeader } from 'shared/ui/tables/_common/ui/TableHeader';
import { CollapsableTableInner } from 'shared/ui/tables/CollapsableTable/ui/CollapsableTableInner';
import { Column } from 'shared/ui/tables/_common/types';
import { ColorPalette } from 'shared/consts/colorPalette';

interface Props<T> extends TableProps {
	columns: Array<Column<T>>;
	subTables: Record<string, Array<T & { id: string }>>;
	pagination?: {
		page: number;
		totalCount: number;
		perPage: number;
		onPageChange: (page: number) => void;
	};
}
export function CollapsableTable<T>({ columns, subTables, pagination }: Props<T>) {
	const firstRow = Object.values(subTables)[0][0];
	return (
		<>
			<TableContainer>
				<MUITable>
					<TableHead>
						<TableRow>
							<TableCell
								sx={{ padding: '17px 0px', borderBottom: 'none' }}
								colSpan={columns.length}
							>
								<TableHeader columns={columns} additionalData={firstRow} />
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<TableRow>
							<TableCell sx={{ padding: 0, borderBottom: 'none' }} colSpan={columns.length}>
								{Object.keys(subTables).map((subTableId) => (
									<CollapsableTableInner
										key={subTableId}
										columns={columns}
										rows={subTables[subTableId]}
										title={subTableId}
									/>
								))}
							</TableCell>
						</TableRow>
					</TableBody>
				</MUITable>
			</TableContainer>
			{pagination && (
				<Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
					<Pagination
						page={pagination.page}
						sx={{
							'& .MuiPaginationItem-root': {
								'color': ColorPalette.astronaut,
								'&.Mui-selected': {
									color: ColorPalette.white,
								},
							},
						}}
						color="primary"
						size="small"
						onChange={(e, value) => {
							pagination.onPageChange(value);
						}}
						count={Math.ceil(pagination.totalCount / pagination.perPage)}
					/>
				</Box>
			)}
		</>
	);
}
